module.exports = __webpack_public_path__ + "img/5_61.5f173220.png";